import { EpDetail } from '@bumble/app/__generated__/data-contracts';
import DataTableGrid from '@bumble/app/components/DataTableGrid';
import NoData from '@bumble/app/components/NoData';
import { Indicator } from '@bumble/app/components/Indicator';
import { GridColDef } from '@mui/x-data-grid';
import { DateTime } from 'luxon';

const columns: GridColDef[] = [
  {
    field: 'name',
    headerName: 'Name',
    flex: 1,
    minWidth: 200,
    disableColumnMenu: true,
  },
  {
    field: 'user_agent_id',
    headerName: 'User Agent Id',
    width: 200,
    disableColumnMenu: true,
  },
  {
    field: 'email',
    headerName: 'Email',
    width: 200,
    disableColumnMenu: true,
  },
  {
    field: 'description',
    headerName: 'Description',
    width: 500,
    disableColumnMenu: true,
  },
  {
    field: 'created_at',
    headerName: 'Created at',
    minWidth: 150,
    disableColumnMenu: true,
    valueGetter: (value) => {
      if (value === null) return '';
      return DateTime.fromISO(value).toLocaleString(DateTime.DATETIME_SHORT);
    },
  },
  {
    field: 'admin_state',
    headerName: 'Admin State',
    width: 150,
    disableColumnMenu: true,
  },
  {
    field: 'admin_state_change_at',
    headerName: 'Admin State changed at',
    minWidth: 200,
    disableColumnMenu: true,
    valueGetter: (value) => {
      if (value === null) return '';
      return DateTime.fromISO(value).toLocaleString(DateTime.DATETIME_SHORT);
    },
  },
  {
    field: 'op_state',
    headerName: 'Op State',
    width: 100,
    disableColumnMenu: true,
    renderCell: (params) => {
      return params.value !== undefined ? <Indicator active={params.value === 'up'} /> : 'N/A';
    }
  },
  {
    field: 'op_state_change_at',
    headerName: 'Op State changed at',
    minWidth: 200,
    disableColumnMenu: true,
    valueGetter: (value) => {
      if (value === null) return '';
      return DateTime.fromISO(value).toLocaleString(DateTime.DATETIME_SHORT);
    },
  },
  {
    field: 'last_auth_time',
    headerName: 'Last Authentication Time',
    minWidth: 200,
    disableColumnMenu: true,
    valueGetter: (value) => {
      if (value === null) return '';
      return DateTime.fromISO(value).toLocaleString(DateTime.DATETIME_SHORT);
    },
  },
  {
    field: 'last_auth_status',
    headerName: 'Last Authentication Status',
    width: 200,
    headerAlign: 'right',
    align: 'right',
    disableColumnMenu: true,
  },
];

const columnVisible = {
  name: true,
  email: true,
  description: true,
  created_at: true,
  admin_state: true,
  admin_state_change_at: true,
  op_state: true,
  op_state_change_at: true,
  last_auth_time: true,
  last_auth_status: true,
  user_agent_id: true,
};

export const EndpointTabAgents = ({ data }: { data: EpDetail | undefined }) => {
  if (data === undefined) return <NoData />;

  return (
    <DataTableGrid
      rows={
        data?.user_agents.map((item) => {
          return {
            ...item,
            id: item.user_agent_id,
          };
        }) || []
      }
      columns={columns}
      columnVisibilityModel={columnVisible}
    />
  );
};
